import { useEffect, useState } from "react";

/**
 * Live MM:SS countdown driven by an ISO timestamp. Stops at 00:00.
 * Renders inline; the caller controls surrounding chrome.
 */
export function MiniCountdown({ expiresAt, showLabel = true, size = "md" }) {
  const [ms, setMs] = useState(0);
  useEffect(() => {
    const tick = () => setMs(Math.max(0, new Date(expiresAt).getTime() - Date.now()));
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [expiresAt]);
  const m = Math.floor(ms / 60000);
  const s = Math.floor((ms % 60000) / 1000);
  const cls = size === "sm" ? "text-xl" : size === "lg" ? "text-5xl" : "text-4xl";
  return (
    <span data-testid="mini-countdown" className="inline-flex items-baseline gap-2">
      <span className={`font-display tabular-nums text-champagne ${cls}`}>
        {String(m).padStart(2, "0")}:{String(s).padStart(2, "0")}
      </span>
      {showLabel && <span className="font-label text-[9px] text-ivory/70">left to secure it</span>}
    </span>
  );
}

export default MiniCountdown;
